import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Colour, SubType, VehicleMake, VehicleInspectionWearPattern } from '@quorum/models/xs-resource';
import { Observable } from 'rxjs';
import { AppointmentCardLineItemsDialogComponent } from '../appointment-card-line-items-dialog/appointment-card-line-items-dialog.component';

@Component({
  selector: 'quorum-appointment-card',
  templateUrl: './appointment-card.component.html',
  styleUrls: ['./appointment-card.component.scss'],
})
export class AppointmentCardComponent implements OnInit {
  @Input() appointmentData: any;
  @Input() vehicleDropdowns$: Observable<{
    colours: Colour[];
    subTypes: SubType[];
    makes: VehicleMake[];
    inspectionWearPatterns: VehicleInspectionWearPattern[];
  }>;
  @Output() checkIn: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}

  displayLineItems() {
    const dialogRef = this.dialog.open(AppointmentCardLineItemsDialogComponent, {
      disableClose: true,
      data: {
        vehicleId: this.appointmentData.vehicle.id,
        appointmentId: this.appointmentData.appointment.id,
      },
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.initiateCheckIn();
      }
    });
  }

  initiateCheckIn() {
    this.checkIn.emit(true);
  }
}
